// packages/web/src/api/query-keys.ts
import type {
  UsersListData,
  HoursEntriesAdminWeekData,
  WorkordersListData,
} from "./generated/types.gen";

type UsersListParams = NonNullable<UsersListData["query"]>;
type AdminWeekParams = NonNullable<HoursEntriesAdminWeekData["query"]>;
type WorkordersListParams = NonNullable<WorkordersListData["query"]>;

export const queryKeys = {
  costCenters: {
    _def: ["cost-centers"] as const,
    list: () => ["cost-centers", "list"] as const,
    byId: (id: string) => ["cost-centers", "byId", id] as const,
  },
  users: {
    _def: ["users"] as const,
    list: (params: UsersListParams) => ["users", "list", params] as const,
    facets: () => ["users", "facets"] as const,
    byId: (id: string) => ["users", "byId", id] as const,
  },
  userReplacements: {
    _def: ["userReplacements"] as const,
    list: () => ["userReplacements", "list"] as const,
    byId: (id: string) => ["userReplacements", "byId", id] as const,
  },
  invites: {
    _def: ["invites"] as const,
    byToken: (token: string) => ["invites", "byToken", token] as const,
  },
  me: {
    _def: ["me"] as const,
    mfaSetup: () => ["me", "mfaSetup"] as const,
  },
  hoursEntries: {
    _def: ["hours-entries"] as const,
    adminWeek: (params: AdminWeekParams) => ["hours-entries", "admin-week", params] as const,
    byId: (id: string) => ["hours-entries", "byId", id] as const,
  },
  dayBreaks: {
    _def: ["day-breaks"] as const,
    byId: (id: string) => ["day-breaks", "byId", id] as const,
    byUserDate: (userId: string, date: string) =>
      ["day-breaks", "byUserDate", userId, date] as const,
  },
  workorders: {
    _def: ["workorders"] as const,
    list: (params: WorkordersListParams) => ["workorders", "list", params] as const,
    byId: (id: string) => ["workorders", "byId", id] as const,
  },
} as const;
